// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-supply{color:#fff}.item-supply .invisible{visibility:hidden}.item-supply .chip{margin:4px 0 0;display:inline-block;width:auto;padding:5px 7px;background:#353539;text-align:center;font-size:12px;text-transform:uppercase;border-radius:7px}", ""]);
// Exports
module.exports = exports;
